import { WifiSlash } from "@phosphor-icons/react";
import styled from "styled-components";

export default function ConnectionStatus() {
  return (
    <Container>
      <WifiSlash size={24} />
    </Container>
  );
}

export const Container = styled.div`
  position: fixed;
  top: 10px;
  right: 20px;
  color: ${(props) => props.theme.colors.primary}; /* Cor vermelha para indicar offline */
  animation: blink-animation 1s infinite; /* Animação de piscar */
  z-index: 1000;

  @keyframes blink-animation {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
